import { useState } from "react";
import { Api } from "../../common/Api";
import { notification } from "antd";

export const useSystemSettings = () => {
  const [systemSettings, setSystemSettings] = useState({ idReviewEmail: [] });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadSystemSettings = () => {
    setLoading(true);
    Api.setting
      .systemSettings()
      .then((res) => {
        setSystemSettings(res.data.systemSettings);
      })
      .finally(() => setLoading(false));
  };

  const save = (data: any) => {
    setSaving(true);
    return Api.setting
      .saveSystemSettings({ ...systemSettings, ...data })
      .then((res) => {
        notification.success({ message: `Successfully` });
        loadSystemSettings();
      })
      .finally(() => setSaving(false));
  };

  return {
    systemSettings,
    saving,
    loadSystemSettings,
    save,
    loading,
  };
};
